// ─── /sections: qué períodos se ven y qué secciones se leen (puro, con test) ──
// Un seminario con historia importada tiene 129 períodos y 1.027 secciones:
// la página escuchaba todas y dibujaba 130 tarjetas. Ahora los períodos vigentes
// van abiertos, los cerrados plegados en un grupo que se abre de a
// CLOSED_PAGE_SIZE, y solo se leen las secciones de los períodos a la vista.

/** Un período cerrado; cualquier otro estado (o ninguno) cuenta como vigente. */
export function isClosedTerm(term: { status?: unknown }): boolean {
  return term.status === 'closed';
}

export const CLOSED_PAGE_SIZE = 20;

/** Los lotes de ids para `termId in` (tope 30). Los vigentes, de a 30; los
 *  cerrados, por página: así abrir otra página agrega un lote y no vuelve a
 *  suscribir (ni a leer) los que ya estaban. */
export function termIdChunks(
  activeIds: readonly string[],
  closedShownIds: readonly string[],
): string[][] {
  const chunks: string[][] = [];
  for (let i = 0; i < activeIds.length; i += 30) chunks.push(activeIds.slice(i, i + 30));
  for (let i = 0; i < closedShownIds.length; i += CLOSED_PAGE_SIZE) {
    chunks.push(closedShownIds.slice(i, i + CLOSED_PAGE_SIZE));
  }
  return chunks;
}
